import React from 'react';
import {Alert, Modal, Text} from '@forecast-it/design-system';
import {FormattedHTMLMessage, FormattedMessage, useIntl} from 'react-intl';

type ProjectsBillingDetailsWarningModalProps = {
	closeModal: () => void;
};

const ProjectsBillingDetailsWarningModal = ({closeModal}: ProjectsBillingDetailsWarningModalProps): JSX.Element => {
	const {formatMessage} = useIntl();
	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id="invoicing.billing_details_required" />
			</Modal.Title>
			<Modal.Content>
				<Alert text={formatMessage({id: 'invoicing.missing_billing_details'})} type={Alert.TYPE.ERROR} />
				<Text>
					<FormattedHTMLMessage id={'invoicing.projects_no_common_invoicing_pathway'} />
				</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={closeModal}>
					<FormattedMessage id={'common.cancel'} />
				</Modal.PrimaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default ProjectsBillingDetailsWarningModal;
